<div *ngIf="pageLoading" class="{{'loadingOverlay center-loader'}}">
    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
    </p-progressSpinner>
</div>

<div class="automation-rules-section">
    <div class="automation-rules-header">
        <h3 class="automation-rules-title">Automation Rules</h3>
        <button *ngIf="userPrivileges.has('event_stage_rule.create')" pButton pRipple type="button" class="add-rule-btn"
            (click)="addRule(stage)">
            <em class="pi pi-plus"></em>
            <span>Add Rule</span>
        </button>
    </div>

    <div class="timeline-container" *ngIf="stage_rules && stage_rules.length > 0">
        <div class="timeline-item" *ngFor="let stage_rule of stage_rules; index as rule_index"
            [ngClass]="{'left': rule_index % 2 === 0, 'right': rule_index % 2 === 1}">

            <div class="timeline-dot"></div>

            <div class="rule-card" *ngIf="stage_rule.isShowSummary">
                <div class="rule-card-header">
                    <span class="rule-number">Rule {{ rule_index + 1 }}</span>
                    <div class="rule-actions">
                        <button *ngIf="userPrivileges.has('event_stage_rule.update')" class="rule-action-btn"
                            (click)="editRule(stage_rules[rule_index])" pTooltip="Edit" tooltipPosition="top">
                            <em class="pi pi-pencil"></em>
                        </button>
                        <button *ngIf="userPrivileges.has('event_stage_rule.delete')" class="rule-action-btn delete"
                            (click)="removeRule(stage_rule.id, $event, rule_index)" pTooltip="Delete"
                            tooltipPosition="top">
                            <em class="pi pi-trash"></em>
                        </button>
                    </div>
                </div>

                <div class="rule-card-content">
                    <div class="rule-chip-row">
                        <span class="rule-chip when">WHEN</span>
                        <span class="rule-chip-value">
                            <p-skeleton width="6rem" height="1rem"
                                *ngIf="!stage_rules[rule_index].trigger"></p-skeleton>
                            <span *ngIf="stage_rules[rule_index].trigger">{{ stage_rules[rule_index].trigger.name
                                }}</span>
                        </span>
                    </div>

                    <div class="rule-chip-row">
                        <span class="rule-chip condition">CONDITION</span>
                        <span class="rule-chip-value">
                            <p-skeleton width="6rem" height="1rem"
                                *ngIf="!stage_rules[rule_index].stageCondition"></p-skeleton>
                            <span *ngIf="stage_rules[rule_index].stageCondition">{{
                                stage_rules[rule_index].stageCondition.name }}</span>
                        </span>
                    </div>

                    <div class="condition-details"
                        *ngIf="stage_rules[rule_index].stageCondition?.name === 'Matching Condition'">
                        <div class="condition-item" *ngFor="let condition of stage_rules[rule_index].conditionsList">
                            <span class="condition-index">{{ stage_rules[rule_index].conditionsList.indexOf(condition) +
                                1 }}</span>
                            <span class="condition-text">
                                {{ condition.values.conditionSource?.name }}
                                {{ condition.values.conditionClause?.sign }}
                                <ng-container *ngIf="condition.values.conditionSource?.inputType === 'Date Picker'">
                                    {{ formatDate(condition.values.conditionValue.value) }}
                                </ng-container>
                                <ng-container *ngIf="condition.values.conditionSource?.inputType !== 'Date Picker'">
                                    <ng-container *ngIf="condition.values.conditionSource?.label === 'mark_percentage'">
                                        {{ condition.values.conditionValue.value }}%
                                    </ng-container>
                                    <ng-container *ngIf="condition.values.conditionSource?.label !== 'mark_percentage'">
                                        {{ getDisplayValue(condition) }}
                                    </ng-container>
                                </ng-container>
                            </span>
                        </div>
                    </div>

                    <div class="rule-chip-row">
                        <span class="rule-chip action">POSITIVE ACTION</span>
                        <div class="rule-actions-list">
                            <div class="action-item" *ngFor="let action of stage_rules[rule_index].actionsList">
                                <span class="action-name">{{ action.values.actionName?.name }}</span>
                                <span class="action-template" *ngIf="action.values.actionTemplate">
                                    {{ action.values.actionTemplate?.name }}
                                </span>
                                <div class="action-details-row"
                                    *ngIf="action.values.actionName?.name === 'Send Document Form' && action.values.actionFormDetails">
                                    <div class="action-detail-item">
                                        <em class="pi pi-briefcase detail-icon"></em>
                                        <div class="detail-content">
                                            <span class="detail-label">Job Role</span>
                                            <span class="detail-value">{{
                                                getJobRoleLabel(action.values.actionFormDetails?.job_role_id) || '-'
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="action-detail-item">
                                        <em class="pi pi-user detail-icon"></em>
                                        <div class="detail-content">
                                            <span class="detail-label">Document POC</span>
                                            <span class="detail-value">{{
                                                action.values.actionFormDetails?.documentation_poc_username || '-'
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="action-detail-item">
                                        <em class="pi pi-clock detail-icon"></em>
                                        <div class="detail-content">
                                            <span class="detail-label">Submission Deadline</span>
                                            <span class="detail-value">{{
                                                action.values.actionFormDetails?.submission_deadline || '-' }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="action-details-row"
                                    *ngIf="action.values.actionName?.name === 'Send Offer Form' && action.values.actionFormDetails">
                                    <div class="action-detail-item">
                                        <em class="pi pi-briefcase detail-icon"></em>
                                        <div class="detail-content">
                                            <span class="detail-label">Job Role</span>
                                            <span class="detail-value">{{
                                                getJobRoleLabel(action.values.actionFormDetails?.job_role_id) || '-'
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="action-detail-item">
                                        <em class="pi pi-map-marker detail-icon"></em>
                                        <div class="detail-content">
                                            <span class="detail-label">Job Location</span>
                                            <span class="detail-value">{{
                                                getLocationsLabel(action.values.actionFormDetails?.job_locations) || '-'
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="action-detail-item">
                                        <em class="pi pi-clock detail-icon"></em>
                                        <div class="detail-content">
                                            <span class="detail-label">Offer Deadline</span>
                                            <span class="detail-value">{{
                                                action.values.actionFormDetails?.submission_deadline || '-' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="rule-chip-row"
                        *ngIf="stage_rules[rule_index].stageCondition?.name === 'Matching Condition' && stage_rules[rule_index].elseActionsList?.length">
                        <span class="rule-chip action negative">NEGATIVE ACTION</span>
                        <div class="rule-actions-list">
                            <div class="action-item" *ngFor="let action of stage_rules[rule_index].elseActionsList">
                                <span class="action-name">{{ action.values.actionName?.name }}</span>
                                <span class="action-template" *ngIf="action.values.actionTemplate">
                                    {{ action.values.actionTemplate?.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="timeline-line"></div>

        <div class="timeline-end-dot"></div>
    </div>

    <div class="timeline-empty" *ngIf="!stage_rules || stage_rules.length === 0">
        <div class="empty-icon">
            <em class="pi pi-sparkles"></em>
        </div>
        <p class="empty-text">No automation rules configured yet.</p>
    </div>
</div>

<p-dialog [visible]="showRuleDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
    [style]="{ width: '800px', maxWidth: '95vw' }" [baseZIndex]="0" class="neo-dialog">

    <div class="dialog-wrapper" *ngIf="currentRuleIndex >= 0 && stage_rules[currentRuleIndex]">
        <div class="dialog-header">
            <h2 class="dialog-title">{{ ruleDialogTitle }}</h2>
            <button type="button" class="dialog-close-btn" (click)="closeRuleDialog()" aria-label="Close">
                <em class="pi pi-times"></em>
            </button>
        </div>

        <div class="dialog-content">
            <div class="content-wrapper">
                <form class="send-email-form">
                    <div class="form-field">
                        <label class="field-label">When <span class="required-asterisk">*</span></label>
                        <p-select optionLabel="name" [(ngModel)]="stage_rules[currentRuleIndex].trigger"
                            [options]="getAvailableTriggers()" class="form-dropdown"
                            [ngModelOptions]="{standalone: true}" placeholder="Select trigger" appendTo="body"
                            (onChange)="getTriggers(stage_rules[currentRuleIndex].trigger, currentRuleIndex)">
                        </p-select>
                    </div>

                    <div class="form-field">
                        <label class="field-label">Condition <span class="required-asterisk">*</span>
                            <span class="field-subtitle">(Which one would you like to apply the rule?)</span>
                        </label>
                        <p-select optionLabel="name" [(ngModel)]="stage_rules[currentRuleIndex].stageCondition"
                            [options]="stage_rule_condition" class="form-dropdown" [ngModelOptions]="{standalone: true}"
                            placeholder="Select condition" appendTo="body">
                        </p-select>
                    </div>

                    <div class="form-field neo-input-wrapper"
                        *ngIf="stage_rules[currentRuleIndex].stageCondition?.name === 'Matching Condition' && stage_rules[currentRuleIndex].conditionsList.length > 1">
                        <label class="field-label">Logic Operator</label>
                        <div class="radioButtons">
                            <ng-container *ngFor="let operator of stage_condition_operators">
                                <p-radioButton name="logic_operator" [value]="operator"
                                    [(ngModel)]="stage_rules[currentRuleIndex].logicCondition"
                                    [inputId]="operator.id + 'dialog'" [ngModelOptions]="{standalone: true}">
                                </p-radioButton>
                                <label [for]="operator.id + 'dialog'"
                                    [ngClass]="{'selected-radio': stage_rules[currentRuleIndex].logicCondition?.id === operator.id}">
                                    {{ operator.name }}
                                </label>
                            </ng-container>
                        </div>
                    </div>

                    <div class="consitionSet"
                        *ngIf="stage_rules[currentRuleIndex].stageCondition?.name === 'Matching Condition'">
                        <div class="conditionSet-logic">
                            <ng-container
                                *ngFor="let operator of stage_rules[currentRuleIndex].logicOperator; let i = index">
                                <span *ngIf="i > 0">
                                    {{ stage_rules[currentRuleIndex].logicCondition?.name }}
                                    <div class="flow-lines"></div>
                                </span>
                            </ng-container>
                        </div>
                        <div [style]="{display: 'flex', flexDirection: 'column'}">
                            <div class="conditionSet-individual"
                                *ngFor="let condition of stage_rules[currentRuleIndex].conditionsList">
                                <span class="consitionSet-index">{{
                                    stage_rules[currentRuleIndex].conditionsList.indexOf(condition) + 1 }}</span>
                                <span class="p-input-icon-right">
                                    <em [ngClass]="{'pi pi-spin pi-spinner': loadConditionOptions}"></em>
                                    <p-select class="consitionSet-specific" [emptyMessage]="'Please select triggers'"
                                        optionLabel="name" [options]="condition.specific"
                                        [(ngModel)]="condition.values.conditionSource"
                                        [ngModelOptions]="{standalone: true}"
                                        (onChange)="selectOperatorOptions($event, condition)" #conditionSpecifc
                                        [panelStyle]="{
                                            'min-width': conditionSpecifc.el.nativeElement.offsetWidth + 'px',
                                            'max-width': conditionSpecifc.el.nativeElement.offsetWidth + 'px'
                                        }" [overlayOptions]="{styleClass: 'no-wrap-option'}">
                                    </p-select>
                                </span>
                                <p-select class="consitionSet-specific" optionLabel="sign"
                                    [options]="condition.operator" [(ngModel)]="condition.values.conditionClause"
                                    [ngModelOptions]="{standalone: true}" #conditionClause [panelStyle]="{
                                        'min-width': conditionClause.el.nativeElement.offsetWidth + 'px',
                                        'max-width': conditionClause.el.nativeElement.offsetWidth + 'px'
                                    }">
                                </p-select>
                                <ng-container [ngSwitch]="condition.values.conditionSource?.inputType">
                                    <div class="neo-input-wrapper" *ngSwitchCase="'Date Picker'">
                                        <p-datepicker whitebg smbr iconDisplay="input"
                                            [(ngModel)]="condition.values.conditionValue.value" [showIcon]="true"
                                            dateFormat="yy-mm-dd" [showTime]="false" [showSeconds]="false"
                                            [ngModelOptions]="{standalone: true}" yearRange="1900:2050"
                                            placeholder="Select Date" [style]="{'width':'100%'}"
                                            class="consitionSet-specific" (onSelect)="onDateSelect($event, condition)">
                                        </p-datepicker>
                                    </div>

                                    <ng-container *ngSwitchDefault>
                                        <div *ngIf="condition.values.conditionSource?.label === 'mark_percentage'"
                                            class="percentage-input-container">
                                            <input class="consitionSet-specific percentage-input" pInputText type="text"
                                                [(ngModel)]="condition.values.conditionValue.value"
                                                [ngModelOptions]="{standalone: true}"
                                                [placeholder]="'percentage (0-100)'" />
                                            <span class="percentage-symbol">%</span>
                                        </div>

                                        <ng-container
                                            *ngIf="condition.values.conditionSource?.label !== 'mark_percentage'">
                                            <ng-container
                                                [ngSwitch]="(condition.values.conditionSource?.inputType === 'Dropdown' || condition.values.conditionSource?.inputType === 'Multi-dropdown' || condition.values.conditionSource?.inputType === 'Radio'  || condition.values.conditionSource?.inputType === 'Checkbox') ? 'dropdown' : 'input'">
                                                <p-select *ngSwitchCase="'dropdown'" class="consitionSet-specific"
                                                    [options]="condition.values.conditionSource?.options"
                                                    #conditionSource [panelStyle]="{
                                                        'min-width': conditionSource.el.nativeElement.offsetWidth + 'px',
                                                        'max-width': conditionSource.el.nativeElement.offsetWidth + 'px'
                                                    }" [(ngModel)]="condition.values.conditionValue.value"
                                                    [ngModelOptions]="{standalone: true}" [filter]="true"
                                                    optionLabel="label" optionValue="value"
                                                    (onFilter)="filterInstitute($event, condition)"
                                                    [emptyFilterMessage]="loadingInstitutions ? 'Searching...' : 'No results found'"
                                                    [emptyMessage]="loadingInstitutions ? 'Searching...' : 'No results found'"
                                                    (onShow)="onInstitutionDropdownShow($event, condition.values.conditionSource?.options, condition)"
                                                    (onHide)="onInstitutionDropdownHide($event, condition.values.conditionSource?.options, condition)">
                                                    <ng-template let-item pTemplate="item">
                                                        <div pTooltip="{{item.label}}" tooltipPosition="top"
                                                            [tooltipStyleClass]="'custom-tooltip'">
                                                            {{item.label}}
                                                        </div>
                                                    </ng-template>
                                                </p-select>
                                                <input *ngSwitchCase="'input'" class="consitionSet-specific" pInputText
                                                    [(ngModel)]="condition.values.conditionValue.value"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [placeholder]="'Enter value'" />
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <div class="consitionSet-icons">
                                    <em class="pi pi-plus addIcon-plus"
                                        (click)="addCondition(condition, currentRuleIndex)"></em>
                                    <em class="pi pi-minus removeIcon-minus"
                                        [ngClass]="{'disabled': stage_rules[currentRuleIndex].conditionsList.length <= 1}"
                                        (click)="removeCondition(condition, currentRuleIndex)"></em>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="header-tabs"
                        *ngIf="stage_rules[currentRuleIndex].stageCondition?.name === 'Matching Condition'">
                        <button type="button" class="tabs positive"
                            [ngClass]="{'selected': stage_rules[currentRuleIndex].displayAction}"
                            (click)="stage_rules[currentRuleIndex].displayAction = true; stage_rules[currentRuleIndex].displayElseAction = false">Positive</button>
                        <button type="button" class="tabs negative"
                            [ngClass]="{'selected': stage_rules[currentRuleIndex].displayElseAction}"
                            (click)="stage_rules[currentRuleIndex].displayAction = false; stage_rules[currentRuleIndex].displayElseAction = true">Negative</button>
                    </div>

                    <div class="form-field neo-input-wrapper"
                        *ngIf="stage_rules[currentRuleIndex].displayAction || stage_rules[currentRuleIndex].stageCondition?.name == 'For All'">
                        <div class="stage-actions">
                            <div class="stage-actions-dropdown"
                                *ngFor="let action of stage_rules[currentRuleIndex].actionsList; let actionIndex = index">
                                <div class="action-fields-row">
                                    <!-- Action Field -->
                                    <div class="form-field action-field">
                                        <label class="field-label">Action <span
                                                class="required-asterisk">*</span></label>
                                        <p-select class="form-dropdown" [options]="getFilteredActions(action.actions)"
                                            optionLabel="name" [(ngModel)]="action.values.actionName"
                                            [ngModelOptions]="{standalone: true}" placeholder="Select action"
                                            appendTo="body"
                                            (onChange)="selectTemplateOptions($event.value.name, action, actionIndex, stage_rules[currentRuleIndex].actionsList)"
                                            #actionSelect [panelStyle]="{
                                                'min-width': actionSelect.el.nativeElement.offsetWidth + 'px',
                                                'max-width': actionSelect.el.nativeElement.offsetWidth + 'px'
                                            }" [overlayOptions]="{styleClass: 'no-wrap-option'}">
                                        </p-select>
                                    </div>
                                    <div class="form-field action-field"
                                        *ngIf="action.template.length && action.values.actionName?.name !== 'Send Document Form' && action.values.actionName?.name !== 'Send Offer Form'">
                                        <label class="field-label">
                                            {{ action.values.actionName?.name === 'Move Candidate To Stage' ? 'Select Stage' : 'Email
                                            Template' }}
                                            <span class="required-asterisk">*</span>
                                        </label>
                                        <p-select class="form-dropdown" [options]="action.template"
                                            (onChange)="setActionValues($event.value, action.values)" optionLabel="name"
                                            [filter]="true" filterBy="name" [(ngModel)]="action.values.actionTemplate"
                                            [ngModelOptions]="{standalone: true}"
                                            [placeholder]="action.values.actionName?.name === 'Move Candidate To Stage' ? 'Select stage' : 'Select template'"
                                            appendTo="body" #templateSelect [panelStyle]="{
                                                'min-width': templateSelect.el.nativeElement.offsetWidth + 'px',
                                                'max-width': templateSelect.el.nativeElement.offsetWidth + 'px'
                                            }">
                                        </p-select>
                                    </div>
                                    <em class="pi pi-minus deleteActionIcon removeIcon-minus"
                                        *ngIf="stage_rules[currentRuleIndex].actionsList.length > 1"
                                        (click)="removeAction(action, currentRuleIndex)"></em>
                                </div>
                                <span *ngIf="stageError && action.values.actionName?.name == 'Move Candidate To Stage'"
                                    [style]="{color: 'red', fontSize: '12px', marginLeft: '1vw'}">No stages to
                                    move</span>
                                <div class="action-form-details"
                                    *ngIf="action.values.actionName?.name === 'Send Document Form'">
                                    <div class="form-field">
                                        <label class="field-label">Job Role <span
                                                class="required-asterisk">*</span></label>
                                        <p-select class="form-dropdown" optionLabel="label" optionValue="value"
                                            [options]="ruleActionFormData.jobRolesList"
                                            [(ngModel)]="action.values.actionFormDetails.job_role_id"
                                            [ngModelOptions]="{standalone: true}" placeholder="Select Job Role"
                                            appendTo="body">
                                        </p-select>
                                    </div>
                                    <div class="form-field">
                                        <label class="field-label">Document POC Role<span class="required-asterisk">*</span></label>
                                        <p-select class="form-dropdown" optionLabel="name" optionValue="id"
                                            [options]="ruleActionFormData.roles"
                                            (onChange)="onDocumentPOCRoleChange($event.value, action)"
                                            [(ngModel)]="action.values.actionFormDetails.documentation_poc_role_id"
                                            [ngModelOptions]="{standalone: true}" placeholder="Select POC Role"
                                            appendTo="body">
                                        </p-select>
                                    </div>
                                    <div class="form-field">
                                        <label class="field-label">Documentation POC <span
                                                class="required-asterisk">*</span></label>
                                        <p-select class="form-dropdown" optionLabel="label" optionValue="value"
                                            [options]="ruleActionFormData.eventUsers"
                                            [(ngModel)]="action.values.actionFormDetails.documentation_poc_id"
                                            [ngModelOptions]="{standalone: true}" placeholder="Select Documentation POC"
                                            appendTo="body">
                                        </p-select>
                                    </div>
                                    <div class="form-field">
                                        <label class="field-label">Submission Deadline <span
                                                class="required-asterisk">*</span></label>
                                        <p-select class="form-dropdown" optionLabel="label" optionValue="value"
                                            [options]="ruleActionFormData.deadlineList"
                                            [(ngModel)]="action.values.actionFormDetails.submission_deadline"
                                            [ngModelOptions]="{standalone: true}" placeholder="Select Deadline"
                                            appendTo="body">
                                        </p-select>
                                    </div>
                                </div>
                                <div class="action-form-details"
                                    *ngIf="action.values.actionName?.name === 'Send Offer Form'">
                                    <div class="form-field">
                                        <label class="field-label">Job Role <span
                                                class="required-asterisk">*</span></label>
                                        <p-select class="form-dropdown" optionLabel="label" optionValue="value"
                                            [options]="ruleActionFormData.jobRolesList"
                                            [(ngModel)]="action.values.actionFormDetails.job_role_id"
                                            [ngModelOptions]="{standalone: true}"
                                            (onChange)="onRuleJobRoleChange(action, $event.value)"
                                            placeholder="Select Job Role" appendTo="body">
                                        </p-select>
                                    </div>
                                    <div class="form-field">
                                        <label class="field-label">Job Location <span
                                                class="required-asterisk">*</span></label>
                                        <p-multiselect class="form-dropdown" optionLabel="label" optionValue="value"
                                            [options]="action.values.actionFormDetails.availableLocations || []"
                                            [(ngModel)]="action.values.actionFormDetails.job_locations"
                                            [ngModelOptions]="{standalone: true}" placeholder="Select Job Location"
                                            display="chip" appendTo="body">
                                        </p-multiselect>
                                    </div>
                                    <div class="form-field">
                                        <label class="field-label">Offer Deadline <span
                                                class="required-asterisk">*</span></label>
                                        <p-select class="form-dropdown" optionLabel="label" optionValue="value"
                                            [options]="ruleActionFormData.deadlineList"
                                            [(ngModel)]="action.values.actionFormDetails.submission_deadline"
                                            [ngModelOptions]="{standalone: true}" placeholder="Select Offer Deadline"
                                            appendTo="body">
                                        </p-select>
                                    </div>
                                </div>
                                <div class="email-template-preview"
                                    *ngIf="action.values.actionName?.name === 'Send Email' && action.values.actionTemplateContent">
                                    <div class="form-field neo-input-wrapper">
                                        <label class="field-label">Subject <span
                                                class="required-asterisk">*</span></label>
                                        <input type="text" pInputText class="form-input"
                                            [value]="action.values.actionTemplate?.name || ''" readonly />
                                    </div>
                                    <div class="form-field neo-input-wrapper">
                                        <label class="field-label">Message <span
                                                class="required-asterisk">*</span></label>
                                        <div class="template-display"
                                            [innerHTML]="action.values.actionTemplateContent | getSafeHTMLEmail"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-action-link" (click)="addNewAction(stage_rules[currentRuleIndex].actionsList)">
                            <em class="pi pi-plus-circle"></em>
                            <span>Add Action</span>
                        </div>
                    </div>

                    <div class="form-field neo-input-wrapper"
                        *ngIf="stage_rules[currentRuleIndex].displayElseAction && stage_rules[currentRuleIndex].stageCondition?.name == 'Matching Condition'">
                        <div class="stage-actions">
                            <div class="stage-actions-dropdown"
                                *ngFor="let action of stage_rules[currentRuleIndex].elseActionsList; let elseActionIndex = index">
                                <div class="action-fields-row">
                                    <div class="form-field action-field">
                                        <label class="field-label">Negative Action <span
                                                class="required-asterisk">*</span></label>
                                        <p-select class="form-dropdown" [options]="getFilteredActions(action.actions)"
                                            optionLabel="name" [(ngModel)]="action.values.actionName"
                                            [ngModelOptions]="{standalone: true}" placeholder="Select action"
                                            appendTo="body"
                                            (onChange)="selectTemplateOptions($event.value.name, action, elseActionIndex, stage_rules[currentRuleIndex].elseActionsList)"
                                            #elseActionSelect [panelStyle]="{
                                                'min-width': elseActionSelect.el.nativeElement.offsetWidth + 'px',
                                                'max-width': elseActionSelect.el.nativeElement.offsetWidth + 'px'
                                            }" [overlayOptions]="{styleClass: 'no-wrap-option'}">
                                        </p-select>
                                    </div>
                                    <div class="form-field action-field"
                                        *ngIf="action.template.length && action.values.actionName?.name !== 'Send Document Form' && action.values.actionName?.name !== 'Send Offer Form'">
                                        <label class="field-label">
                                            {{ action.values.actionName?.name === 'Move Candidate To Stage' ? 'Select Stage' : 'Email
                                            Template' }}
                                            <span class="required-asterisk">*</span>
                                        </label>
                                        <p-select class="form-dropdown" [options]="action.template"
                                            (onChange)="setActionValues($event.value, action.values)" optionLabel="name"
                                            [filter]="true" filterBy="name" [(ngModel)]="action.values.actionTemplate"
                                            [ngModelOptions]="{standalone: true}"
                                            [placeholder]="action.values.actionName?.name === 'Move Candidate To Stage' ? 'Select stage' : 'Select template'"
                                            appendTo="body" #elseTemplateSelect [panelStyle]="{
                                                'min-width': elseTemplateSelect.el.nativeElement.offsetWidth + 'px',
                                                'max-width': elseTemplateSelect.el.nativeElement.offsetWidth + 'px'
                                            }">
                                        </p-select>
                                    </div>
                                    <em class="pi pi-minus deleteActionIcon removeIcon-minus"
                                        *ngIf="stage_rules[currentRuleIndex].elseActionsList.length > 1"
                                        (click)="removeElseAction(action, currentRuleIndex)"></em>
                                </div>
                                <span *ngIf="stageError && action.values.actionName?.name == 'Move Candidate To Stage'"
                                    [style]="{color: 'red', fontSize: '12px', marginLeft: '1vw'}">No stages to
                                    move</span>
                                <div class="action-form-details"
                                    *ngIf="action.values.actionName?.name === 'Send Document Form'">
                                    <p-select class="ruleSet-dropdown" optionLabel="label" optionValue="value"
                                        [options]="ruleActionFormData.jobRolesList"
                                        [(ngModel)]="action.values.actionFormDetails.job_role_id"
                                        [ngModelOptions]="{standalone: true}" placeholder="Job Role"
                                        [style]="{'min-width':'140px'}"></p-select>
                                    <p-select class="ruleSet-dropdown" optionLabel="name" optionValue="id"
                                        [options]="ruleActionFormData.roles"
                                        (onChange)="onDocumentPOCRoleChange($event.value, action)"
                                        [(ngModel)]="action.values.actionFormDetails.documentation_poc_role_id"
                                        [ngModelOptions]="{standalone: true}" placeholder="Document POC Role"
                                        [style]="{'min-width':'140px'}"></p-select>
                                    <p-select class="ruleSet-dropdown" optionLabel="label" optionValue="value"
                                        [options]="ruleActionFormData.eventUsers"
                                        [(ngModel)]="action.values.actionFormDetails.documentation_poc_id"
                                        [ngModelOptions]="{standalone: true}" placeholder="Documentation POC"
                                        [style]="{'min-width':'140px'}"></p-select>
                                    <p-select class="ruleSet-dropdown" optionLabel="label" optionValue="value"
                                        [options]="ruleActionFormData.deadlineList"
                                        [(ngModel)]="action.values.actionFormDetails.submission_deadline"
                                        [ngModelOptions]="{standalone: true}" placeholder="Submission Deadline"
                                        [style]="{'min-width':'140px'}"></p-select>
                                </div>
                                <div class="action-form-details"
                                    *ngIf="action.values.actionName?.name === 'Send Offer Form'">
                                    <p-select class="ruleSet-dropdown" optionLabel="label" optionValue="value"
                                        [options]="ruleActionFormData.jobRolesList"
                                        [(ngModel)]="action.values.actionFormDetails.job_role_id"
                                        [ngModelOptions]="{standalone: true}"
                                        (onChange)="onRuleJobRoleChange(action, $event.value)" placeholder="Job Role"
                                        [style]="{'min-width':'140px'}"></p-select>
                                    <p-multiselect class="ruleSet-dropdown" optionLabel="label" optionValue="value"
                                        [options]="action.values.actionFormDetails.availableLocations || []"
                                        [(ngModel)]="action.values.actionFormDetails.job_locations"
                                        [ngModelOptions]="{standalone: true}" placeholder="Job Location"
                                        [style]="{'min-width':'140px'}" display="chip"></p-multiselect>
                                    <p-select class="ruleSet-dropdown" optionLabel="label" optionValue="value"
                                        [options]="ruleActionFormData.deadlineList"
                                        [(ngModel)]="action.values.actionFormDetails.submission_deadline"
                                        [ngModelOptions]="{standalone: true}" placeholder="Offer Deadline"
                                        [style]="{'min-width':'140px'}"></p-select>
                                </div>
                                <div class="email-template-preview"
                                    *ngIf="action.values.actionName?.name === 'Send Email' && action.values.actionTemplateContent">
                                    <div class="form-field neo-input-wrapper">
                                        <label class="field-label">Subject <span
                                                class="required-asterisk">*</span></label>
                                        <input type="text" pInputText class="form-input"
                                            [value]="action.values.actionTemplate?.name || ''" readonly />
                                    </div>
                                    <div class="form-field neo-input-wrapper">
                                        <label class="field-label">Message <span
                                                class="required-asterisk">*</span></label>
                                        <div class="template-display"
                                            [innerHTML]="action.values.actionTemplateContent | getSafeHTMLEmail"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-action-link"
                            (click)="addNewElseAction(stage_rules[currentRuleIndex].elseActionsList)">
                            <em class="pi pi-plus-circle"></em>
                            <span>Add Action</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- Footer -->
        <div class="dialog-footer">
            <button pButton pRipple type="button" label="Cancel" class="p-button-outlined cancel-btn"
                (click)="closeRuleDialog()"></button>
            <button pButton pRipple type="button" label="Save" class="send-invite-btn" [loading]="loadingButton"
                (click)="saveWorkflow(stage_rules[currentRuleIndex]?.id, currentRuleIndex)"
                [ngClass]="{'invalid': checkValidation(stage_rules[currentRuleIndex])}"
                [disabled]="checkValidation(stage_rules[currentRuleIndex])"></button>
        </div>
    </div>
</p-dialog>

<p-toast></p-toast>
<p-confirmpopup></p-confirmpopup>